export default __webpack_public_path__ + "static/media/switch-book-tool.ca2033e2.svg";